// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"0":"vendors","19":"main"}[chunkId] + "." + {"0":"e88c1c1f76225ae2a2cb","19":"61f70b75c11f052a5d83"}[chunkId] + ".min.css";
};